/**
 * Created by Mark on 17/04/2017.
 */




import React  from 'react';
import CurriculumServices from '../services/curriculums-services.js';
import CurriculumStore from '../store/curriculum-store.js';
import Layout from '../components/layouts/standard-page.js';
import Card from '../components/card.js';
import CardBody from '../components/card-body.js';
import CardHeader from '../components/card-header.js';
import LessonPlanService from '../services/lessonplan-services.js';
import LessonPlanStore from '../store/lessonplan-store.js';
import { FormattedMessage } from 'react-intl';
import CDNImage from '../components/media/image.js';
import fuzzysearch from 'fuzzysearch';
import InternationalizationStore from '../store/internationalization-store.js';
import Select from  'react-select';
import {Row , Col} from 'react-bootstrap';

export default class LessonPlansComponent extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            plans:[],
            allPlans:[],
            selectedLanguage:{ value: 'en' , label:'English'}
        }
    }


    componentDidMount() {
        LessonPlanService.getAll()
    }

    componentWillMount(){
        LessonPlanStore.on("CHANGE" , () => {
            this.setState({
                plans:LessonPlanStore.getPlans(),
                allPlans:LessonPlanStore.getPlans()
            });
        });
    }

    handelKeyDown(){
        clearTimeout(this.state.typingTimer);
    }

    handelKeyUp(){
        clearTimeout(this.state.typingTimer);

        this.setState({
            typingTimer:setTimeout(function(){ this.handelUserSearch(this.search.value) }.bind(this), 500)
        });
    }

    handelUserSearch(searchTerm){

        var searchTerm = searchTerm.trim();

        if(searchTerm.length <= 3)
        {
            this.setState({plans:this.state.allPlans});
            return
        }


        var searchedRows = [];

        for(var idx = 0; idx < this.state.allPlans.length; idx++)
        {
            if(!this.state.allPlans[idx]) continue;

            var title   = InternationalizationStore.getTranslation('ui-'+this.state.allPlans[idx].title_translation_uid);
            //var summary   = InternationalizationStore.getTranslation('ui-'+this.state.allPlans[idx].summary_translation_uid);

            if(fuzzysearch(String(searchTerm).toLowerCase() , String(title).toLowerCase()))
            {
                searchedRows.push(this.state.allPlans[idx]);
            }
            //else if(fuzzysearch(String(searchTerm).toLowerCase() , String(summary).toLowerCase()))
            //{
               // searchedRows.push(this.state.allPlans[idx]);
            //}

        }

        this.setState({plans:searchedRows})
    }

    handelFilter(option){
        this.setState({selectedLanguage:option})
    }

    lessonPlanThumb(){

        var plans = [];

        for(var idx = 0 ; idx < this.state.plans.length; idx++)
        {
            if(this.state.plans[idx].target_ietf != this.state.selectedLanguage.value) continue;

            plans.push(<div className="col-sm-6 col-md-4">
                <div className="thumbnail">
                    <div className="placeholder">
                        <CDNImage size={150} isVocab src={this.state.plans[idx].icon_path} />
                    </div>
                    <div className="caption">
                        <h4 className="titletextOverflow"><img className="avatar-img small" src={"img/flags/"+this.state.plans[idx].target_ietf+".png"} alt=""/>  <FormattedMessage id={ "ui-"+this.state.plans[idx].title_translation_uid } defaultMessage={ "No Results Found" }/></h4>
                        <p className="text-justify textOverflow" ><FormattedMessage id={ "ui-"+this.state.plans[idx].summary_translation_uid } defaultMessage={ "No Results Found" }/></p>
                        <div className="m-b-5">
                            <a href={"https://assets.languagenut.com"+this.state.plans[idx].download_path} target="_blank" className="palette-Branding secondary bg btn btn-block waves-effect" role="button">
                                <span className="palette-White text">Download</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>)
        }

        return plans;
    }

    render(){

        const options = [{ value: 'en' , label:'English'} , { value: 'es', label:'Spanish'} , { value: 'fr', label:'French'} , { value: 'de', label: 'German'}]
        return (<Layout>
                   <Card>
                       <CardHeader>
                           <h2>Lesson Plans</h2>
                       </CardHeader>
                       <CardBody>
                               <Row className="p-b-10">
                                   <Col md={4}>
                                        <Select onChange={this.handelFilter.bind(this)}value={this.state.selectedLanguage} options={options} />
                                   </Col>
                               </Row>
                               <div className="row">
                                    {this.lessonPlanThumb()}
                               </div>
                           </CardBody>
                   </Card>
                </Layout>);
    }
}


// WEBPACK FOOTER //
// ./src/screens/lesson-plans.js